import { render, staticRenderFns } from "./cross-legal-transactions.vue?vue&type=template&id=09328457&"
import script from "./cross-legal-transactions.ts?vue&type=script&lang=js&"
export * from "./cross-legal-transactions.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports